export class ApproverMapModel {
    Department_Code: string = '';
    Department_Name: string = '';
    Department_Status: boolean = false;
    Sub_Dept_Code: string = '';
    Sub_Dept_Name: string = '';
    Sub_Dept_Status: boolean = false;
    DeptRepCodes: number[] = [];
    JVAdvisorCode: number = 0;
    DeptViewerCodes: number[] = [];
    DeptRepName: string = '';
    JVAdvisorName: string = '';
    DeptViewerName: string = '';
    Created_By: number = 0;    
}